export default {
  bundleTitle: {
    id: 'product_page_recommendation_bundle_title',
    defaultMessage: 'Often bought together',
  },
  metaDescription: {
    id: 'product_meta_description',
    defaultMessage:
      '{category} {brand} {title} ✌ Up to 70% off compared to new ✅ Free delivery ✅ Cheap {model} ✅ {warrantyDuration} year warranty ✅ {coolingOffDays}-day money-back guarantee',
  },
  newTreePlanted: {
    id: 'new_tree_planted',
    defaultMessage: '1 tree planted',
  },
  productVatIncludedInfo: {
    id: 'product_vat_included_info',
    defaultMessage: '',
  },
  productVatFaqLink: {
    id: 'product_vat_faq_link',
    defaultMessage: '',
  },
  productVatFaq: {
    id: 'product_vat_faq',
    defaultMessage: 'Learn more',
  },
  productPageNotFoundError: {
    id: 'product_page_not_found_error',
    defaultMessage: 'Product not found',
  },
  strikedPriceExplanation: {
    id: 'stroked_price_explanation',
    defaultMessage:
      "Crossed out prices may be the manufacturer's suggested retail price, or may be calculated from the average price of the product from different retail distributors.",
  },
  productVatIncluded: {
    id: 'product_vat_included',
    defaultMessage: 'VAT inclusive',
  },
  warrantyRefund: {
    id: 'product_page_warranty_refund',
    defaultMessage: '{days}-day hassle-free returns',
  },
}
